import type {ColumnFragment, ValueInstanceFragment} from "app/gql/graphqlSchema";
import {IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle} from "@ionic/react";
import {isNotBlank} from "app/utils/stdlib";
import {DisplayValueInstance} from "app/employee/controlCard/DisplayValueInstance";
import {DisplayValueInstanceError} from "app/employee/controlCard/input/DisplayValueInstanceError";
import {useHasControlCardValueError} from "app/employee/controlCard/hook/useHasControlCardValueError";
import {InputIonCard} from "app/employee/controlCard/input/InputIonCard";
import {useControlCardInstanceContext} from "app/employee/controlCard/ControlCardInstanceContext";

interface Props {
  column: {__typename?: "ControlCardLabelColumn"} & ColumnFragment;
  valueInstance: ValueInstanceFragment;
  disabled?: boolean;
}

export const InputLabel = ({column, valueInstance, disabled}: Props) => {
  const hasError = useHasControlCardValueError(valueInstance);
  const {isComplete, canEdit, instance} = useControlCardInstanceContext();

  const localDisabled = isComplete || !canEdit || !!disabled;

  return (
    <InputIonCard $hasError={hasError} data-scroll-to-value-instance-id={valueInstance.id}>
      <IonCardHeader>
        <IonCardTitle>{column.title}</IonCardTitle>
        {isNotBlank(column.description) && <IonCardSubtitle>{column.description}</IonCardSubtitle>}
      </IonCardHeader>
      <IonCardContent>
        <DisplayValueInstance
          column={column}
          columnRefOptions={instance.columnRefOptions}
          valueInstance={valueInstance}
        />
        <DisplayValueInstanceError column={column} disabled={localDisabled} valueInstance={valueInstance} />
      </IonCardContent>
    </InputIonCard>
  );
};
